import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
} from "firebase/firestore";

function TopBalance() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const snap = await getDocs(collection(db, "users"));

      let list = snap.docs.map((d) => {
        const data = d.data();

        const wager = data.wager || 0;
        const wallet = data.withdrawable || 0;

        return {
          id: d.id,
          name: data.name || "User",
          email: data.email || "",
          wager,
          wallet,
          total: wager + wallet,
        };
      });

      // 🔥 sort by total balance
      list.sort((a, b) => b.total - a.total);

      // 🔥 top 20
      list = list.slice(0, 20);

      setUsers(list);

    } catch (e) {
      console.error(e);
    }
  };

  // 🔍 SEARCH
  const filtered = users.filter((u) => {
    const s = search.toLowerCase();

    return (
      u.name.toLowerCase().includes(s) ||
      u.email.toLowerCase().includes(s) ||
      u.id.toLowerCase().includes(s)
    );
  });

  return (
    <div style={container}>
      <h1>🧮 Top Balance Users</h1>

      <input
        placeholder="🔍 Search name / email / UID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={searchBox}
      />

      <div style={grid}>
        {filtered.map((u, i) => (
          <div key={u.id} style={card}>
            <h3>#{i + 1} {u.name}</h3>
            <p>{u.email}</p>
            <p>🆔 {u.id}</p>

            <p>🎯 Wager: ₹{u.wager}</p>
            <p>💼 Wallet: ₹{u.wallet}</p>

            <p style={total}>
              🧮 Total: ₹{u.total}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

/* STYLES */

const container = {
  padding: 20,
  color: "white",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const searchBox = {
  width: "100%",
  padding: 10,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.1)",
  background: "#1A1F2E",
  color: "#fff",
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 20,
};

const card = {
  background: "#1A1F2E",
  padding: 16,
  borderRadius: 12,
};

const total = {
  marginTop: 10,
  fontWeight: "bold",
  color: "#22c55e",
};

export default TopBalance;